import { DropdownButton, MenuItem } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { MessagingType } from 'models/automation/CustomTemplates';
import { useNavigate } from 'react-router-dom';
import { TEMPLATE_TYPE_QUERY_PARAM } from '../modal/CustomTemplateAddEditModal.constants';

const AddCustomTemplatesButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToAdd = (templateType: MessagingType) => {
    navigate({
      pathname: './add',
      search: new URLSearchParams({
        [TEMPLATE_TYPE_QUERY_PARAM]: templateType,
      }).toString(),
    });
  };

  return (
    <DropdownButton
      id="add-custom-templates-button"
      bsStyle="primary"
      title={t('pageAutomations.customTemplates.create.title')}
    >
      <MenuItem onClick={() => goToAdd(MessagingType.EMAIL)}>
        {t('pageAutomations.customTemplates.create.email')}
      </MenuItem>
      <MenuItem onClick={() => goToAdd(MessagingType.SMS)}>
        {t('pageAutomations.customTemplates.create.sms')}
      </MenuItem>
      <MenuItem onClick={() => goToAdd(MessagingType.WHATSAPP)}>
        {t('pageAutomations.customTemplates.create.whatsapp')}
      </MenuItem>
    </DropdownButton>
  );
};

export default AddCustomTemplatesButton;
